/**
 * TanStack Query hooks for `kpi-visibility-per-report-per-role`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	kpiVisibilityPerReportPerRoleQueryKeys,
	type CreateKpiVisibilityPerReportPerRoleBody,
	type ListKpiVisibilityPerReportPerRoleResponse,
	type KpiVisibilityPerReportPerRoleRow,
} from "./api";

export function useKpiVisibilityPerReportPerRoleList(): UseQueryResult<ListKpiVisibilityPerReportPerRoleResponse, Error> {
	return useQuery({
		queryKey: kpiVisibilityPerReportPerRoleQueryKeys.list(),
		queryFn: list,
	});
}

export function useKpiVisibilityPerReportPerRoleCreate(): UseMutationResult<KpiVisibilityPerReportPerRoleRow, Error, CreateKpiVisibilityPerReportPerRoleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiVisibilityPerReportPerRoleQueryKeys.all });
		},
	});
}

export function useKpiVisibilityPerReportPerRoleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiVisibilityPerReportPerRoleQueryKeys.all });
		},
	});
}
